export const uiOutlineClass = "outline-2 outline-offset-2";
